import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GalleryDetail from "../pages/gallery/page";
import Careers from "../pages/careers/page";
import Projects from "../pages/projects/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/projects",
    element: <Projects />,
  },
  {
    path: "/gallery/:slug",
    element: <GalleryDetail />,
  },
  {
    path: "/careers",
    element: <Careers />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
